module.exports = __webpack_public_path__ + "img/25.195c13e3.png";